import React, { useState, useEffect } from 'react';
import axios from "axios";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './CompetenciesView.css'

import { apiUrl } from '../../../utility/Connections';

import { Typography, Layout, Divider, Button, Input } from 'antd';
import FileUploaderAuto from '../../../components/fileUploader/fileUploaderAuto';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import Search from '../../../components/search/search';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import TableCompetenciesLevels from '../../../components/tableCompetenciesLevels/tableCompetenciesLevels';
import FormCompetenciesLevels from '../../../components/formCompetenciesLevels/formCompetenciesLevels';
import TableCompetencies from '../../../components/tableCompetencies/tableCompetencies';
import { PlusSquareOutlined } from '@ant-design/icons';
import ModalCompetence from '../../../components/modalCompetence/modalCompetence';
const { Paragraph, Title } = Typography;
const { Content } = Layout;

const CompetenciesView = () => {

    const [orgId, setOrgId] = useState(false);
    const [dataCompetencies, setDataCompetencies] = useState([]);
    const [filteredDataCompetencies, setFilteredDataCompetencies] = useState([]);
    const [searchTextCMP, setSearchTextCMP] = useState("");
    const [dataJobTitles, setDataJobTitles] = useState([]);
    const [dataCompetenciesLevels, setDataCompetenciesLevels] = useState([]);
    const [filteredDataCompetenciesLevels, setFilteredDataCompetenciesLevels] = useState([]);
    const [searchTextCL, setSearchTextCL] = useState("");
    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [fileCharged, setFileCharged] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");

    const [newCompetence, setNewCompetence] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    // States para el modal de competencias
    const [cmpId, setCmpId] = useState(null);
    const [cmpCompetence, setCmpCompetence] = useState("");
    const [cmpDescription, setCmpDescription] = useState("");
    const [cmpDescriptors, setCmpDescriptors] = useState([]);
    const [dataCompetence, setDataCompetence] = useState({});

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getCMPandJTTCL(current_org.org_id);
        }
    }, []);

    // Función para asignar valores del backend a los estados
    useEffect(() => {
        if (dataCompetence) {
            setCmpId(dataCompetence.cmp_id || null);
            setCmpCompetence(dataCompetence.cmp_competence || null);
            setCmpDescription(dataCompetence.cmp_description || null);
            setCmpDescriptors(dataCompetence.cmp_descriptors || []);
        }
    }, [dataCompetence]);

    const handleChangeFile = () => {
        setFileCharged(false)
    }

    const selectFile = (files) => {
        setSelectedFile(files[0])
        setFileCharged(true)
    }

    const getCMPandJTTCL = async (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando información. Esto puede tardar un poco...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/competencies/get-competencies/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataCompetencies(data);
                setFilteredDataCompetencies(data);
                getJobTitles(orgId)
                getCompetenciesLevels(orgId)
                // setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getCompetencies = async (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando información. Esto puede tardar un poco...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/competencies/get-competencies/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataCompetencies(data);
                if (searchTextCMP) {
                    filterDataCMP(searchTextCMP, data)
                } else {
                    setFilteredDataCompetencies(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getJobTitles = async (orgId) => {
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/job-titles/get-job-titles/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataJobTitles(data);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getCompetenciesLevels = async (orgId) => {

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/competencies-levels/get-competencies-levels/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataCompetenciesLevels(data);
                setShowLoading(false);
                if (searchTextCL) {
                    filterDataCL(searchTextCL, data)
                } else {
                    setFilteredDataCompetenciesLevels(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const uploadFile = async () => {
        setShowLoading(true);
        setLoadingText("Guardando competencias. Esto puede tardar un poco...");

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("org_id", orgId);

        const token = localStorage.getItem('access_token');
        
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        }

        axios
            .post(`${apiUrl}/files/upload-competencies/`, formData, headers)
            .then(function (response) {
                // getUploadedFiles();
                resetStates();
                getCMPandJTTCL(orgId);
                showSwal(response.data.message, 2, "Correcto");
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
                console.error(`Error: ${error}`);
            });
    };

    const resetStates = () => {
        setFileCharged(false)
        setSelectedFile("")
    }

    // Función para agregar un nuevo registro de cargo
    const addCompetenceLevel = (newCompetenceLevel) => {
        setShowLoading(true);
        setLoadingText("Agregando nivel de competencia...")

        const formData = new FormData();
        formData.append("cl_org_id", orgId);
        formData.append("cl_level", newCompetenceLevel);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/competencies-levels/create-competence-level/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getCompetenciesLevels(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para editar el nombre de un cargo
    const handleInputChangeTableCL = (cl_id, competenceLevel) => {
        setShowLoading(true);
        setLoadingText("Guardando nivel de competencia...")

        const formData = new FormData();
        formData.append("cl_id", cl_id);
        formData.append("cl_level", competenceLevel);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/competencies-levels/update-competence-level/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getCompetenciesLevels(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para eliminar un registro de cargo
    const handleDeleteTableCL = (cl_id) => {
        setShowLoading(true);
        setLoadingText("Eliminando nivel de competencia...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.delete(`${apiUrl}/competencies-levels/delete-competence-level/${cl_id}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getCompetenciesLevels(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const onSearchCMP = (value) => {
        setSearchTextCMP(value)
        filterDataCMP(value, dataCompetenciesLevels)
    }

    const filterDataCMP = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataCompetencies(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.cmp_competence.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataCompetencies(filtered);
        }
    }

    const onSearchCL = (value) => {
        setSearchTextCL(value)
        filterDataCL(value, dataCompetenciesLevels)
    }

    const filterDataCL = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataCompetenciesLevels(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.cl_level.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataCompetenciesLevels(filtered);
        }
    }

    const setCompetenceValuesToSee = (cmp) => {
        setShowLoading(true);
        setNewCompetence(false);
        setLoadingText("Cargando información de la competencia...")
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .get(`${apiUrl}/competencies/get-competence-by-id/${cmp.cmp_id}/`, headers)
            .then(function (response) {
                const data = response.data.competence
                setNewCompetence(false);
                setModalVisible(true);
                setDataCompetence(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const openNewCompetence = () => {
        let objCompetence = {
            cmp_id: null,
            cmp_competence: "",
            cmp_description: "",
            cmp_descriptors: [],
        }
        for (let index = 0; index < dataCompetenciesLevels.length; index++) {
            const element = dataCompetenciesLevels[index];
            let objCategory = {
                category_id: element.cl_id,
                category_name: element.cl_level,
                descriptors: new Array(10).fill(null),
                job_titles: element.job_titles || [],
            }
            objCompetence.cmp_descriptors.push(objCategory)
        }
        setDataCompetence(objCompetence);
        setNewCompetence(true);
        setModalVisible(true);
    }

    const saveCompetence = () => {
        setShowLoading(true);
        setLoadingText("Guardando edición de la competencia...")
        setModalVisible(false);

        const formData = new FormData();

        formData.append("cmp_org_id", orgId);
        formData.append("cmp_id", cmpId);
        formData.append("cmp_competence", cmpCompetence);
        formData.append("cmp_description", cmpDescription);
        // formData.append("cmp_descriptors", cmpDescriptors);
        formData.append("cmp_descriptors", JSON.stringify(cmpDescriptors));


        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .post(`${apiUrl}/competencies/save-competence/`, formData, headers)
            .then(function (response) {
                setNewCompetence(false);
                showSwal(response.data.message, 2, "Correcto");
                setModalVisible(false);
                getCompetencies(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                // showSwal(error.data.error, 0, "Error");
                console.error('There was an error!', error);
                setModalVisible(true);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const createCompetence = () => {
        setShowLoading(true);
        setLoadingText("Guardando competencia...")
        const formData = new FormData();

        formData.append("cmp_org_id", orgId);
        formData.append("cmp_competence", cmpCompetence);
        formData.append("cmp_description", cmpDescription);
        formData.append("cmp_descriptors", cmpDescriptors);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .post(`${apiUrl}/competencies/create-competence/`, formData, headers)
            .then(function (response) {
                setNewCompetence(false);
                setModalVisible(false);
                showSwal(response.data.message, 2, "Correcto");
                getCompetencies(orgId);
                // setShowLoading(false);
            })
            .catch(function (error) {
                // showSwal(error.data.error, 0, "Error");
                console.error('There was an error!', error);
                // setModalVisible(true);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            {/* <SideMenuAdmin /> */}
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Carga de competencias</Title>
                    <Paragraph>
                        Configure y cargue sus archivos desde esta sección. Siga los siguientes pasos:
                        <ol style={{ marginTop: 10, marginBottom: 10 }}>
                            <li>Haz clic en el cargador o arrastra tu archivo a la zona de carga</li>
                            <li>Haz clic en el botón "Cargar competencias"</li>
                        </ol>
                    </Paragraph>
                </Typography>
                <div className='display-center-row display-center-column align-full-center'>
                    <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                        {
                            fileCharged ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                <p className='filename-tag'>{selectedFile.name}</p>
                                <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFile}>Cambiar archivo</Button>
                            </div> : <div className='display-center-row display-center-column uploader-container'>
                                <FileUploaderAuto mostrarData={selectFile} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                            </div>
                        }
                    </div>
                    <Button style={{ width: 'auto' }} type="primary" onClick={uploadFile} disabled={!fileCharged}>Cargar competencias</Button>
                </div>
            </div>
            <Divider />
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Gestión de niveles de competencia</Title>
                </Typography>
                <FormCompetenciesLevels addCompetenceLevel={addCompetenceLevel} />
                <Divider />
                <Search onSearch={onSearchCL} />
                <br></br>
                <TableCompetenciesLevels data={filteredDataCompetenciesLevels} handleInputChange={handleInputChangeTableCL} handleDelete={handleDeleteTableCL} />
            </div>
            <Divider />
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Gestión de competencias</Title>
                </Typography>
                <Typography className='display-center-row display-center-column'>
                    <Button onClick={openNewCompetence} icon={<PlusSquareOutlined />}>Crear competencia</Button>
                </Typography>
                <Divider />
                <Search onSearch={onSearchCMP} />
                <br></br>
                <div className='display-center-row display-center-column'>
                    <TableCompetencies data={filteredDataCompetencies} setCompetenceValuesToSee={setCompetenceValuesToSee} />
                </div>
            </div>
        </Content>
        <ModalCompetence
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            states={{
                cmpId, cmpCompetence, cmpDescription, cmpDescriptors, dataCompetenciesLevels, dataJobTitles
            }}
            setters={{
                setCmpId, setCmpCompetence, setCmpDescription, setCmpDescriptors
            }}
            newCompetence={newCompetence}
            saveCompetence={saveCompetence}
            createCompetence={createCompetence}
        />
    </div>
}

export default CompetenciesView;